import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';  
import { FaUser } from 'react-icons/fa';
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const Modal = ({ isOpen, onClose, branchId, empmobile }) => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    const [employeeData, setEmployeeData] = useState(null); // Start with null
    const [Address, setAddress] = useState('');
    const [BloodGroup, setBloodGroup] = useState('');
    const [DOB, setDob] = useState('');
    const [Age, setAge] = useState('');
    const [Gender, setGender] = useState('');
    const [MaritalStatus, setMaritalStatus] = useState('');
    const [GuardianName, setGuardianName] = useState('');
    const [EmergencyContactName, setEcontactName] = useState('');
    const [EmergencyContactMobile, setEcontactMob] = useState('');
    const [image, setImage] = useState(null);
    const [imageUrl, setImageUrl] = useState('');
    // const udiseNumber= localStorage.getItem("udiseNumber")
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const empmobile = queryParams.get('empmobile');
    const employeeName = queryParams.get('employeeName');
    // const udiseNumber = queryParams.get('udiseNumber');
     const language= localStorage.getItem('language') || 'English';
    
          
    
    const fetchEmployeeDetails = async () => {
        const employeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Personaldetails.json`;
        try {
            const response = await fetch(employeeUrl);
            if (response.ok) {
                const data = await response.json();
                console.log('Fetched Employee Data:', data); // Log to check data structure
                
                setEmployeeData(data);
                setAddress(data.Address || '');
                setBloodGroup(data.BloodGroup || '');
                setDob(data.DOB ? moment(data.DOB, 'DD/MM/YYYY').format('YYYY-MM-DD') : '');
                setGender(data.Gender || '');
                setMaritalStatus(data.MaritalStatus || '');
                setGuardianName(data.GuardianName || '');
                setEcontactName(data.EmergencyContactName || ''); // Corrected the key
                setEcontactMob(data.EmergencyContactMobile || ''); // Corrected the key
            } else {
                console.error("Failed to fetch employee details:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching employee details:", error);
        }
    };
   
    useEffect(() => {
        const fetchImage = async () => {
            const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
            console.log("url",url);
            
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const data = await response.json();
                    setImageUrl(data.Image);
                } else {
                    console.error("Failed to fetch image:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching image:", error);
            }
        };
        fetchImage();
    }, [udiseNumber, empmobile]);

   useEffect(() => {
        if (isOpen) {
            fetchEmployeeDetails();
        }
    }, [isOpen]);

    useEffect(() => {
        if (DOB) {
            const dobDate = moment(DOB, 'YYYY-MM-DD');
            const currentDate = moment();
            const age = currentDate.diff(dobDate, 'years');
            setAge(age);
        }
    }, [DOB]);

    if (!isOpen) return null; // Don't render the modal if it's not open

    const handleSave = async () => {
        const formattedDOB = moment(DOB).format('DD/MM/YYYY');
        const updatedData = {
            Address,
            BloodGroup,
            DOB: formattedDOB,
            Gender,
            MaritalStatus,
            GuardianName,
            EmergencyContactName,
            EmergencyContactMobile,
        };
    
        // Save the image separately
        let imageUrl = null;
        if (image) {
            const imageRef = ref(storage, `ProfileImages/${empmobile}.jpg`);
            await uploadBytes(imageRef, image);
            imageUrl = await getDownloadURL(imageRef);
        }
    
        // Save other data
        const personalDetailsUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Personaldetails.json`;
        
        try {
            // Save personal details
            const response = await fetch(personalDetailsUrl, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedData),
            });
    
            if (response.ok) {
                console.log("Personal details saved successfully!");
    
                // If the image was uploaded, save the image URL in a separate node
                if (imageUrl) {
                    const imageUrlNode = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
                    const imageUpdateResponse = await fetch(imageUrlNode, {
                        method: 'PATCH', // Use PUT to create or replace the image URL
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ Image: imageUrl }), // Save the image URL
                    });
    
                    if (imageUpdateResponse.ok) {
                        console.log("Image URL saved successfully!");
                    } else {
                        console.error("Failed to save image URL:", imageUpdateResponse.statusText);
                    }
                }
    
                onClose(); // Close the modal after saving
            } else {
                console.error("Failed to save personal details:", response.statusText);
            }
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

   const handleImageChange = (e) => {
    setImage(e.target.files[0]);
    setImageUrl(URL.createObjectURL(e.target.files[0]));
};

    const handleDOBChange = (e) => {
        const selectedDOB = e.target.value;
        setDob(selectedDOB);
    };

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <span onClick={onClose} style={modalStyles.closeButton}>✖</span>
                <h2>{language === "English" ? "Personal Details" : "वैयक्तिक माहिती"}</h2>
                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Teacher Name" : "शिक्षकाचे नाव"}</label>
                    <input type="text" value={employeeName || ''} style={modalStyles.input} readOnly />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}</label>
                    <input type="text" value={empmobile|| ''} style={modalStyles.input} readOnly />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Address" : "पत्ता"}</label>
                    <input type="text" value={Address} onChange={(e) => setAddress(e.target.value)} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Date Of Birth" : "जन्मतारीख"}</label>
                    <input
                        type="date"
                        value={DOB}
                        onChange={handleDOBChange}
                        style={modalStyles.input}
                    />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Age" : "वय"}</label>
                    <input type="text" value={Age} readOnly style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Gender" : "लिंग"}</label>
                    <select
                        value={Gender}
                        onChange={(e) => setGender(e.target.value)}
                        style={modalStyles.input}
                    >
                        <option value="">{language === "English" ? "Select Gender" : "लिंग निवडा"}</option>
                        <option value="Male">{language === "English" ? "Male" : "पुरुष"}</option>
                        <option value="Female">{language === "English" ? "Female" : "स्त्री"}</option>
                    </select>
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Marital Status" : "वैवाहिक स्थिती"}</label>
                    <select value={MaritalStatus} onChange={(e) => setMaritalStatus(e.target.value)} style={modalStyles.input}>
                        <option value="">{language === "English" ? "Select Marital Status" : "वैवाहिक स्थिती निवडा"}</option>
                        <option value="Married">{language === "English" ? "Married" : "विवाहित"}</option>
                        <option value="Unmarried">{language === "English" ? "Unmarried" : "अविवाहित"}</option>
                    </select>
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Blood Group" : "रक्तगट"}</label>
                    <input type="text" value={BloodGroup} onChange={(e) => setBloodGroup(e.target.value)} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Guardian's Name" : "पालकाचे नाव"}</label>
                    <input type="text" value={GuardianName} onChange={(e) => setGuardianName(e.target.value)} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Emergency Contact Name" : "आपत्कालीन संपर्क नाव"}</label>
                    <input type="text" value={EmergencyContactName} onChange={(e) => setEcontactName(e.target.value)} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Emergency Contact Mobile" : "आपत्कालीन संपर्क मोबाइल"}</label>
                    <input type="text" value={EmergencyContactMobile} onChange={(e) => setEcontactMob(e.target.value)} style={modalStyles.input} />
                </div>

                 <div style={modalStyles.inputGroup}>
        <label style={modalStyles.label}>{language === "English" ? "Teacher Photo" : "शिक्षकाचे फोटो"}</label>
        <input type="file" onChange={handleImageChange} style={modalStyles.input} />
        {imageUrl && (
            <img src={imageUrl} alt="Teacher Photo" style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover' }} />
        )}
    </div>

                <div style={modalStyles.buttonContainer}>
                    <button onClick={handleSave} style={modalStyles.saveButton}>Save</button>
                </div>
            </div>
        </div>
    );
};


const CurrentEmploymentModal = ({ isOpen, onClose, branchId, empmobile }) => {
 
    const [isTeacher, setIsTeacher] = useState(false);
    const [employmentDetails, setEmploymentDetails] = useState({
        Department: '',
        DOJ: '',
        EmploymentType: '',
        EmployeeID: '',
        PFAccount: '',
        ESIAccount: '',
    });
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
    
    useEffect(() => {
               const storedLanguage = localStorage.getItem('language') || 'English';
               setLanguage(storedLanguage);
             }, []);

const adminmob= localStorage.getItem("udiseNumber")
    const fetchEmploymentDetails = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${adminmob}/AttData/${empmobile}/Currentteacher.json`;
        try {
            const response = await fetch(url);
            if (response.ok) {
                const data = await response.json();
                if (data) {
                    setEmploymentDetails(data);
                    console.log("data",data);
                    
                    setIsTeacher(data.Jobrole === 'Teacher');
                } else {
                    console.error("No employment details found");
                    setEmploymentDetails({
                        Department: '',
                        DOJ: '',
                        EmploymentType: '',
                        EmployeeID: '',
                        PFAccount: '',
                        ESIAccount: '',
                    });
                }
            } else {
                console.error("Failed to fetch employment details:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching employment details:", error);
        }
    };


    useEffect(() => {
        fetchEmploymentDetails();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'DOJ') {
            const formattedDOJ = moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY'); // Convert to DD/MM/YYYY
            console.log("formattedDOJ",formattedDOJ);
            
            setEmploymentDetails((prevDetails) => ({
                ...prevDetails,
                [name]: formattedDOJ,
            }));
        } else {
            setEmploymentDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
            }));
        }
    };

    const handleTeacherCheckboxChange = (e) => {
        setIsTeacher(e.target.checked); // Update checkbox state
    };

    const handleSave = async () => {
        const updatedData = {
          DOJ: employmentDetails.DOJ,
          Department: employmentDetails.Department,
          ESIAccount: employmentDetails.ESIAccount,
          EmployeeID: employmentDetails.EmployeeID,
          EmploymentType: employmentDetails.EmploymentType,
          Jobrole: isTeacher ? 'Teacher' : '',
          PFAccount: employmentDetails.PFAccount,
        };
      
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${adminmob}/AttData/${empmobile}/Currentteacher.json`;
        try {
          const response = await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedData),
          });
      
          if (response.ok) {
            console.log("Data saved successfully!");
            onClose();
          } else {
            console.error("Failed to save data:", response.statusText);
          }
        } catch (error) {
          console.error("Error saving data:", error);
        }
      };
    if (!isOpen) return null;


    const handleDepartmentChange = (e) => {
        const department = e.target.value;
        setEmploymentDetails((prevDetails) => ({
          ...prevDetails,
          Department: department,

        }));
      };

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <span onClick={onClose} style={modalStyles.closeButton}>✖</span>
                <h2 style={{ textAlign: 'center', margin: '20px 0' }}>{language === "English" ? "Employment Record" : "रोजगार माहिती"}</h2>
                

                <div style={{...modalStyles.inputGroup, flexDirection: 'row', marginTop:'15px'}}>
                    <label style={modalStyles.label}>
                     <div style={{display: 'flex'}}>
  <input 
    type="checkbox" 
    checked={isTeacher} 
    onChange={handleTeacherCheckboxChange} 
    style={{ height: '17px', marginTop:'3px', marginRight:'7px'}} 
  />
 <span> {language === "English" ? "Teacher" : "शिक्षक"}</span>
</div>

                    </label>
                  
                </div>
                <div style={modalStyles.inputGroup}>
                <label style={modalStyles.label}>
                {language === "English" ? "Department" : "विभाग"}
                <input type="text" name='Department' value={employmentDetails.Department} onChange={handleDepartmentChange} style={modalStyles.input} />
                </label>
                </div>
                <div style={modalStyles.inputGroup}>
    <label style={modalStyles.label}>{language === "English" ? "Date of Joining " : "रुजु झालेली तारीख"}</label>
    <input
        type="date"
        name="DOJ"
        value={moment(employmentDetails.DOJ, 'DD/MM/YYYY').format('YYYY-MM-DD')} 
        onChange={handleInputChange}
        style={modalStyles.input}
    />
</div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Employement Type" : "रोजगार प्रकार"}</label>
                    <input type="text" name="EmploymentType" value={employmentDetails.EmploymentType} onChange={handleInputChange} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "Employee ID" : "कर्मचारी आयडी"}</label>
                    <input type="text" name='EmployeeID' value={employmentDetails.EmployeeID} onChange={handleInputChange} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "PF Account" : "पीएफ खाते"}</label>
                    <input type="text" name='PFAccount' value={employmentDetails.PFAccount} onChange={handleInputChange} style={modalStyles.input} />
                </div>

                <div style={modalStyles.inputGroup}>
                    <label style={modalStyles.label}>{language === "English" ? "ESI Account" : "ईएसआय खाते"}</label>
                    <input type="text" name='ESIAccount' value={employmentDetails.ESIAccount} onChange={handleInputChange} style={modalStyles.input} />
                </div>

                <div style={modalStyles.buttonContainer}>
                    <button onClick={handleSave} style={modalStyles.saveButton}>Save</button>
                </div>
            </div>
        </div>
    );
};

const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        // left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor:'white',
        width:'89%',
    },
    modal: {
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        width: '600px',
        maxHeight: '80vh', // Set a maximum height for the modal
        overflowY: 'auto', // Enable vertical scrolling
        overflowX: 'hidden',
        textAlign: 'center',
        backgroundColor:'#b0dbfa',
        border:'1px solid black'
    },
    closeButton: {
        top: '10px',
        marginLeft: '520px',
        textAlign: 'right',
        cursor: 'pointer',
        fontSize: '20px',
        color: "red",
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '10px',
    },
    label: {
        marginBottom: '5px',
        fontWeight: 'bold',
    },
    input: {
        width: '100%',
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    buttonContainer: {
        textAlign: 'center',
        marginTop: '20px',
    },
    saveButton: {
        padding: '10px 20px',
        backgroundColor: '#03365e',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
};

function Profile() {
    const location = useLocation(); // Get the location object
    const queryParams = new URLSearchParams(location.search);
    const employeeName = queryParams.get('employeeName'); // Extract employeeName from query params
    const empmobile = queryParams.get('empmobile'); // Extract empmobile from query params
    const adminmob = queryParams.get('adminmob'); // Extract adminmob from query params
    const branchId = queryParams.get('branchId'); // Extract branchId from query params
    const udiseNumber= localStorage.getItem("udiseNumber")
    const [imageUrl, setImageUrl] = useState(''); // State to hold the image URL
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [employeeData, setEmployeeData] = useState({});
    const [isCurrentEmploymentModalOpen, setIsCurrentEmploymentModalOpen] = useState(false);
    const navigate = useNavigate();
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
    
    useEffect(() => {
               const storedLanguage = localStorage.getItem('language') || 'English';
               setLanguage(storedLanguage);
             }, []);


             useEffect(() => {
                const fetchImage = async () => {
                    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
                    try {
                        const response = await fetch(url);
                        if (response.ok) {
                            const data = await response.json();
                            setImageUrl(data.Image);
                        } else {
                            console.error("Failed to fetch image:", response.statusText);
                        }
                    } catch (error) {
                        console.error("Error fetching image:", error);
                    }
                };
        
                fetchImage();
            }, [udiseNumber, empmobile]);

    useEffect(() => {
        const fetchEmployeeDetails = async () => {
            const employeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
            try {
              const response = await fetch(employeeUrl);
              if (response.ok) {
                const employeeData = await response.json();
                setEmployeeData(employeeData);
              } else {
                console.error("Failed to fetch employee details:", response.statusText);
              }
            } catch (error) {
              console.error("Error fetching employee details:", error);
            }
          };
        
        fetchEmployeeDetails();
    }, [adminmob, branchId, empmobile]); 

    const handleClose = () => {
        navigate(-1); // Change '/profile' to the actual path of your profile page
    };

    const handleDelete = async () => {
        const confirmDelete = window.confirm("Do you really want to delete this staff member?");
        if (confirmDelete) {
            const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
            try {
                const response = await fetch(url, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    console.log("Employee deleted successfully!");
                } else {
                    console.error("Failed to delete employee:", response.statusText);
                }
            } catch (error) {
                console.error("Error deleting employee:", error);
            }
        } else {
            console.log("Deletion canceled.");
        }
    };

    const handleMakeInactive = async () => {
        const confirmMakeInactive = window.confirm("Do you want to mark this employee as inactive?");
        if (confirmMakeInactive) {
            const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}.json`;
            try {
                const response = await fetch(url, {
                    method: 'PATCH', // Use PATCH to update only the isInactive field
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ isInactive: true }), // Set isInactive to true
                });

                if (response.ok) {
                    console.log("Employee marked as inactive successfully!");
                } else {
                    console.error("Failed to mark employee as inactive:", response.statusText);
                }
            } catch (error) {
                console.error("Error marking employee as inactive:", error);
            }
        } else {
            console.log("Operation canceled.");
        }
    };

    return (
        <>
            <div className='main-content-of-page' style={{  display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '95vh', 
        backgroundColor: '#f0f0f0', marginTop:'50px'}}>
             <div style={{  width: '60%', 
    border: '1px solid black',
    borderRadius: '20px',
    background: 'linear-gradient(to bottom, rgb(255, 255, 255), rgb(216, 232, 234))' 
}}>
<div>
             <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginTop: '30px', 
                            marginLeft: '905px' 
                        }} onClick={handleClose}> 
                            X 
                        </button>
</div>
                       <div style={{ 
    width: '370px',
    border: '2px solid black',
    marginRight: '1250px',
    marginBottom: '190px',
    borderRadius: '20px',
    position: 'fixed',
    background: 'linear-gradient(to bottom, rgb(8, 68, 107), rgb(193, 236, 247))',
    marginLeft:'90px',
}}>
<div style={{ 
    textAlign: 'center', 
    minHeight: '500px', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    backgroundColor: '#1e1e2f', // Dark background for contrast
    padding: '20px',
    borderRadius: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
}}>
    {/* Profile Image or Default Icon */}
    <div style={{ 
    width: '200px', 
    height: '200px', 
    borderRadius: '50%', 
    border: '4px solid #40E0D0', // Teal border for the image
    overflow: 'hidden', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    backgroundColor: '#2c2c3a' // Background color for the dummy avatar
}}>
    {imageUrl ? (
        <img 
            src={imageUrl} 
            alt="Employee" 
            style={{ 
                width: '100%', 
                height: '100%', 
                borderRadius:'50%', 
                objectFit: 'cover' // Ensures the image covers the circle
            }} 
        />
    ) : (
        <FaUser  
            style={{ 
                fontSize: '120px', // Icon size
                color: '#40E0D0', // Teal color for the icon
            }} 
        />
    )}
    </div>
        <h4 style={{ 
            fontSize: '18px', 
            fontWeight: 'bold', 
            color: 'white', 
            margin:'auto',
            whiteSpace: 'nowrap',
            marginTop: '30px',
            textAlign:'center'
        }}>
      
            {employeeName}
   
        </h4>
        <p style={{ fontSize: '18px', color: 'white' ,textAlign:'center',marginBottom:'150px' }}>{empmobile}</p>
    {/* </div> */}


</div>
</div>
<div style={{float:'right'}}>
  <div style={{ width:'300px',border:'1px solid black', marginRight: '40px',marginTop:'5px',borderRadius:'20px' }}>
                <button style={{
                    marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    marginLeft:'50px',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => setIsModalOpen(true)}>
                    <i className="fa-solid fa-user"></i> {language === "English" ? "Personal Details" : "वैयक्तिक माहिती"}
                </button>

                <button style={{
                     marginBottom: '20px',  
                    marginTop:'10px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => setIsCurrentEmploymentModalOpen(true)}>
                    <i className="fa-solid fa-person"></i> {language === "English" ? "Employement Record" : "रोजगार माहिती"}
                </button>

                <button style={{
                     marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => navigate(`/teacherinfo?adminmob=${adminmob}&branchId=${branchId}&empmobile=${empmobile}&udiseNumber=${udiseNumber}`)}>
                    <i class="fa-solid fa-person-chalkboard"></i> {language === "English" ? "Other Employement Record" : "इतर रोजगार माहिती"}
                </button>
</div>
  <div style={{ width:'300px',border:'1px solid black', marginRight: '40px',marginTop:'25px',borderRadius:'20px' }}>
                <button style={{
                     marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => navigate(`/shift-time?adminmob=${adminmob}&branchId=${branchId}&empmobile=${empmobile}`)}>
                    <i className="fa-solid fa-clock"></i> {language === "English" ? "Set Shift Timings" : "शिफ्ट वेळ सेट करा"}
                </button>

                <button style={{
                     marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => navigate(`/user-permission?adminmob=${adminmob}&branchId=${branchId}&empmobile=${empmobile}&udiseNumber=${udiseNumber}`)}>
                    <i className="fa-solid fa-circle-user"></i> {language === "English" ? "User Permission" : "वापरकर्ता परवानगी"}
                </button>
</div>
<div style={{ width:'300px',border:'1px solid black', marginRight: '40px',marginTop:'25px',borderRadius:'20px' }}>
                <button style={{
                     marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px',
                    marginLeft:'50px', 
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => navigate(`/bank-details?adminmob=${adminmob}&branchId=${branchId}&empmobile=${empmobile}&udiseNumber=${udiseNumber}`)}>
                    <i className="fa-solid fa-building-columns"></i> {language === "English" ? "Bank Details" : "बँक माहिती"}
                </button>
                
                <button style={{
                     marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px',
                    marginLeft:'50px', 
                    borderRadius: '15px',
                    backgroundColor: '#03365e',
                    color: 'white',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={() => navigate(`/salary-details?adminmob=${adminmob}&branchId=${branchId}&empmobile=${empmobile}`)}>
                    <i className="fa-solid fa-indian-rupee-sign"></i> {language === "English" ? "Salary Details " : "पगार तपशील"}
                </button>
</div>
 <div style={{ width:'300px',border:'1px solid black',marginRight: '40px',borderRadius:'20px',marginTop:'25px' }}>
                <button style={{
                    marginBottom: '20px', 
                    marginTop:'13px',
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#dc3545', // Red color for delete button
                    color: '#fff',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }} onClick={handleMakeInactive}>
                    <i className="fa-solid fa-ban"></i> Make Inactive 
                </button>
               
                <button onClick={handleDelete} style={{
                     marginBottom: '20px', 
                    marginTop:'13px', 
                    padding: '10px 20px', 
                    fontSize: '16px', 
                    cursor: 'pointer', 
                    width: '200px', 
                    marginLeft:'50px',
                    borderRadius: '15px',
                    backgroundColor: '#dc3545', // Red color for delete button
                    color: '#fff',
                    border: 'none',
                    transition: 'background-color 0.3s',
                }}>
                    <i className="fa-solid fa-trash"></i> Delete Staff
                </button>
</div>
</div>
</div>
                {/* Modal for Personal Details */}
       
  <Modal 
    isOpen={isModalOpen} 
    onClose={() => setIsModalOpen(false)} 
    employeeData={employeeData} 
    adminmob={adminmob} 
    branchId={branchId} 
    empmobile={empmobile} 
  />

            </div>
            {/* </div> */}
           
            <CurrentEmploymentModal 
                isOpen={isCurrentEmploymentModalOpen} 
                onClose={() => setIsCurrentEmploymentModalOpen(false)} 
                adminmob={adminmob} 
                branchId={branchId} 
                empmobile={empmobile} 
            />
        </>
    );
}

export default Profile;